import { MenuItem, Select, TextField } from "@mui/material";

const BusinessDetailForm = ({ formik, dataSelection }) => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Nama Usaha"
            label="Nama Usaha"
            value={formik.values.data.business_info.name}
            onChange={(e) =>
              formik.setFieldValue("data.business_info.name", e.target.value)
            }
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Alamat Usaha"
            label="Alamat Usaha"
            value={formik.values.data.business_info.address}
            onChange={(e) =>
              formik.setFieldValue("data.business_info.address", e.target.value)
            }
          />
        </div>
        <div className="w-full">
          <Select
            value={
              formik.values.data.business_info.industry_type_id === ""
                ? "none"
                : formik.values.data.business_info.industry_type_id
            }
            onChange={(e) =>
              formik.setFieldValue(
                "data.business_info.industry_type_id",
                e.target.value
              )
            }
            sx={{ width: "100%" }}
          >
            <MenuItem value={"none"} disabled>
              Jenis Industri
            </MenuItem>
            {dataSelection
              ? dataSelection.industry?.map((item) => (
                  <MenuItem value={item.industry_type_id}>
                    {item.industry_type}
                  </MenuItem>
                ))
              : null}
          </Select>
        </div>
        <div className="w-full">
          <Select
            value={
              formik.values.data.business_info.business_type_id === ""
                ? "none"
                : formik.values.data.business_info.business_type_id
            }
            onChange={(e) =>
              formik.setFieldValue(
                "data.business_info.business_type_id",
                e.target.value
              )
            }
            sx={{ width: "100%" }}
          >
            <MenuItem value={"none"} disabled>
              Bidang Usaha
            </MenuItem>
            {dataSelection
              ? dataSelection.business?.map((item) => (
                  <MenuItem value={item.business_ownership_status_id}>
                    {item.business_ownership_status}
                  </MenuItem>
                ))
              : null}
          </Select>
        </div>
        <div className="w-full">
          <Select
            value={
              formik.values.data.business_info.building_type_id === ""
                ? "none"
                : formik.values.data.business_info.building_type_id
            }
            onChange={(e) =>
              formik.setFieldValue(
                "data.business_info.building_type_id",
                e.target.value
              )
            }
            sx={{ width: "100%" }}
          >
            <MenuItem value={"none"} disabled>
              Tipe Bangunan
            </MenuItem>
            {dataSelection
              ? dataSelection.building?.map((item) => (
                  <MenuItem value={item.building_type_id}>
                    {item.building_type}
                  </MenuItem>
                ))
              : null}
          </Select>
        </div>
        <div className="w-full">
          <Select
            value={
              formik.values.data.business_info.business_age_id === ""
                ? "none"
                : formik.values.data.business_info.business_age_id
            }
            onChange={(e) =>
              formik.setFieldValue(
                "data.business_info.business_age_id",
                e.target.value
              )
            }
            sx={{ width: "100%" }}
          >
            <MenuItem value={"none"} disabled>
              Lama Usaha
            </MenuItem>
            {dataSelection
              ? dataSelection.length?.map((item) => (
                  <MenuItem value={item.length_of_business_id}>
                    {item.length_of_business}
                  </MenuItem>
                ))
              : null}
          </Select>
        </div>
        <div className="w-full">
          <Select
            value={
              formik.values.data.business_info.bank_id === ""
                ? "none"
                : formik.values.data.business_info.bank_id
            }
            onChange={(e) =>
              formik.setFieldValue("data.business_info.bank_id", e.target.value)
            }
            sx={{ width: "100%" }}
          >
            <MenuItem value={"none"} disabled>
              Nama Bank
            </MenuItem>
            {dataSelection
              ? dataSelection.bank?.map((item) => (
                  <MenuItem value={item.bank_id}>{item.bank_name}</MenuItem>
                ))
              : null}
          </Select>
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Nama Pemilik Rekening"
            label="Nama Pemilik Rekening"
            value={formik.values.data.business_info.account_name}
            onChange={(e) =>
              formik.setFieldValue(
                "data.business_info.account_name",
                e.target.value
              )
            }
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Nomor Rekening"
            label="Nomor Rekening"
            value={formik.values.data.business_info.account_number}
            onChange={(e) =>
              formik.setFieldValue(
                "data.business_info.account_number",
                e.target.value
              )
            }
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Rata-rata pendapatan perbulan"
            label="Rata-rata pendapatan perbulan"
            type="number"
            onFocus={(e) =>
              e.target.addEventListener(
                "wheel",
                function (e) {
                  e.preventDefault();
                },
                { passive: false }
              )
            }
            value={
              formik.values.data.business_info.average_income
                ? formik.values.data.business_info.average_income.toString()
                : 0
            }
            onChange={(e) => {
              if (!isNaN(Number(e.target.value)))
                formik.setFieldValue(
                  "data.business_info.average_income",
                  Number(e.target.value)
                );
            }}
          />
        </div>
        <div className="w-full">
          <TextField
            fullWidth
            placeholder="Rata-rata margin keuntungan (%)"
            label="Rata-rata margin keuntungan (%)"
            type="number"
            onFocus={(e) =>
              e.target.addEventListener(
                "wheel",
                function (e) {
                  e.preventDefault();
                },
                { passive: false }
              )
            }
            value={
              formik.values.data.business_info.average_profit_percentage
                ? formik.values.data.business_info.average_profit_percentage.toString()
                : 0
            }
            onChange={(e) => {
              if (!isNaN(Number(e.target.value)))
                formik.setFieldValue(
                  "data.business_info.average_profit_percentage",
                  Number(e.target.value)
                );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessDetailForm;
